<h2>Reservations</h2>

<p-table #pt [value]="reservations" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]"
	showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
	[totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"
	selectionMode="single" [globalFilterFields]="['guestProfileVO.lastName','reservationId','orderId']"
	[filterDelay]="1000" [(selection)]=" reservation" dataKey="reservationId" (onRowSelect)="onRowSelect($event)"
	[loading]="loading" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
	[autoLayout]="true" [responsive]="true">

	<ng-template pTemplate="caption">
		<div class="flex">
			<div class="mr-2">
				<span class="p-input-icon-left">
					<i class="pi pi-search"></i>
					<input #global pInputText type="text" (input)="pt.filterGlobal($event.target.value, 'contains')"
						placeholder="Search" />
				</span>
				<button pButton label="Clear" class="ml-2 p-button-outlined" icon="pi pi-filter-slash"
					(click)="clear(pt);"></button>
			</div>
			<div class="ml-auto">
				<button mat-raised-button color="primary" routerLink="/reservation-add">New Reservation +</button>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>

			<th [pSortableColumn]="'reservationStatus'">Status
				<p-sortIcon [field]=""></p-sortIcon>
			</th>
			<th [pSortableColumn]="'shortTermRentalVO.propertyCode'">Property
				<p-sortIcon [field]="'shortTermRentalVO.propertyCode'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'guestProfileVO.firstName'">First Name
				<p-sortIcon [field]="'guestProfileVO.firstName'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'guestProfileVO.lastName'">Last Name
				<p-sortIcon [field]="'guestProfileVO.lastName'"></p-sortIcon>
			</th>
			<th [pSortableColumn]="'checkInDateTime'">Arrival
				<p-sortIcon [field]=""></p-sortIcon>
			</th>
			<th [pSortableColumn]="'checkOutDateTime'">Departure
				<p-sortIcon [field]=""></p-sortIcon>
			</th>
			<th [pSortableColumn]="'orderVO.orderId'">Order #
				<p-sortIcon [field]=""></p-sortIcon>
			</th>
			<th [pSortableColumn]="'reservationId'">Res #
				<p-sortIcon [field]=""></p-sortIcon>
			</th>
		</tr>
		<tr>
			<th>
				<p-multiSelect [options]="constantService.reservationStatuses" defaultLabel="Status"
					(onChange)="pt.filter($event.value, 'reservationStatus', 'in')"></p-multiSelect>
			</th>
			<th>
				<input pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'startsWith')">
			</th>
			<th>
				<input pInputText style="width:150px;" type="text"
					(input)="pt.filter($event.target.value, 'guestProfileVO.firstName', 'startsWith')">
			</th>
			<th>
				<input pInputText style="width:150px;" type="text"
					(input)="pt.filter($event.target.value, 'guestProfileVO.lastName', 'startsWith')">
			</th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
					(input)="pt.filter($event.target.value, 'checkInDate', 'in')"></th>

			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
					(input)="pt.filter($event.target.value, 'checkOutDate', 'in')"></th>
			<th>
				<input pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'orderVO.orderId', 'contains')">
			</th>
			<th>
				<input pInputText style="width:100px;" type="text"
					(input)="pt.filter($event.target.value, 'reservationId', 'contains')">
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-reservation>
		<tr [pSelectableRow]="reservation">
			<td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
				{{getResStatusName(reservation.reservationStatus)}}</td>
			<td>{{reservation.propertyCode}}</td>
			<td><b>{{reservation.guestFirstName}}</b></td>
			<td><b>{{reservation.guestLastName}}</b></td>
			<td style="white-space: nowrap;">{{reservation.checkInDate|date:'MM/dd/yy EEEEEE'}}</td>
			<td style="white-space: nowrap;">{{reservation.checkOutDate|date:'MM/dd/yy EEEEEE'}}</td>
			<td>{{reservation.orderId}} </td>
			<td>{{reservation.reservationId}}</td>
		</tr>
	</ng-template>
	<ng-template pTemplate=" paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}}
	</ng-template>
</p-table>